import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import FileUpload from "react-material-file-upload";
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import bgimage from '../../../../images/default_staff.png';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const OrderCancelled = ({ show, onClose , order }) => {
    const [showAddOnSection, setShowAddOnSection] = useState(true); 
    const [isFocused] = useState(false);
    const [cateringType, setCateringType] = useState([]);
    const [functionType, setFunctionType] = useState([]);
    const [mealsPeriod, setMealsPeriod] = useState([]);
    const [refundDeducted, setRefundDeducted] = useState(0);
    const [refundEligible, setRefundEligible] = useState(0);
    const [refundDays, setRefundDays] = useState(0);
    const [postponeDays, setPostponeDays] = useState(0);
    const BaseUrl = process.env.REACT_APP_API_BASE_URL;
    const navigate = useNavigate();
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);


    useEffect(() => {
        if (isFocused) {
            console.log('The input is focused!');
        }
    }, [isFocused]);

    const handleAddOnToggle = (e) => {
        setShowAddOnSection(e.target.checked);
    };

        const fetchCateringType = async () => {
        try {
                const response = await axios.get(`${BaseUrl}/cateringtype/getactive`);
                if (response.data && Array.isArray(response.data)) {
                    const formatted = response.data.map(item => ({
                        value: String(item.sno),
                        label: item.catering_type
                    }));
                    setCateringType(formatted);
                    console.log(formatted);
                }
            } catch (error) {
                console.error('Failed to fetch Catering Type:', error);
                setCateringType([]);
            }
    };

    const getCateringTypeLabel = (sno) => {
        if (!Array.isArray(cateringType)) return '';
        const found = cateringType.find(ct => ct.value === String(sno));
        return found?.label || '';
    };

    const fetchitemSchedule = async () => {
            try {
                const response = await axios.get(`${BaseUrl}/item-schedule/items/active`);
                
                const list = response.data?.data;
        
                if (Array.isArray(list)) {
                const formatted = list.map(item => ({
                    value: String(item.sno),
                    label: item.itemschedule_name
                }));
                setMealsPeriod(formatted);
                } else {
                setMealsPeriod([]); // fallback to empty array
                }
            } catch (error) {
                console.error('Failed to fetch Meals period:', error);
                setMealsPeriod([]); // fallback to empty array, not object
            }
    };

    const getMealsPeriodLabel = (sno) => {
        if (!Array.isArray(mealsPeriod)) return '';
        const found = mealsPeriod.find(mp => mp.value === String(sno));
        return found?.label || '';
    };

    const fetchFunctionType = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/functiontype/getactive`);
            if (response.data && Array.isArray(response.data)) {
             const formatted = response.data.map(item => ({
                    value: String(item.sno),
                    label: item.function_type
                }));
                setFunctionType(formatted);
            }
        } catch (error) {
            console.error('Failed to Function Type:', error);
            setFunctionType([]);
        }
    };

    const getFunctionTypeLabel = (sno) => {
        if (!Array.isArray(functionType)) return '';
        const found = functionType.find(ft => ft.value === String(sno));
        return found?.label || '';
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    const getSettings = () => {
        axios.get(`${BaseUrl}/generalSetting/1`)
            .then(response => {
                if (response.data && response.data.data) {
                    setRefundDeducted(parseFloat(response.data.data.refund_deducted));
                    setRefundEligible(parseFloat(response.data.data.max_refund_eligible));
                    setRefundDays(parseFloat(response.data.data.max_refund_days));
                    setPostponeDays(parseFloat(response.data.data.max_pospone_days));
                } else {
                    console.log("Unexpected API response structure:", response);
                    
                }
            })
            .catch(error => {
                console.log("Failed to fetch general settings:", error);
            });
    }
    const user_id = parseInt(localStorage.getItem("user_id"), 10);

    const updateCancel = async (order) => {
        const reason = document.querySelector('textarea[name="comment"]').value.trim();
        if (!reason) {
            toast.error("Please enter a reason for cancellation.");
            return;
        }

        // Refund checkbox is selected
        let payload = {
            order_cancellation_reason: reason,
            order_status: 4, // Assuming 4 means Cancelled
        };

        if (showAddOnSection) {
            const refundAmount = document.querySelector('input[placeholder="Enter Refund Amount"]').value.trim();
            if (!refundAmount || isNaN(refundAmount)) {
                toast.error("Please enter a valid refund amount.");
                return;
            }

            payload = {
                ...payload,
                refund_eligible: true,
                refund_amount: refundAmount,
                refund_deducted: refundDeducted,
                refund_days: refundDays,
                refund_eligible_amount: ((Number(order.paid_amount || 0) - Number(refundDeducted || 0)) * (refundEligible || 0) / 100),
                refund_order : order,
                user_id : user_id,
            };
        }

        try {
            const response = await axios.put(`${BaseUrl}/manage_corporate_order/update_order_status/${order.id}/4`, payload);
            if (response.status === 200) {
                toast.success(showAddOnSection ? "Refund requested successfully!" : "Order cancelled successfully!");
                onClose();
                navigate('/manage-corporate-order');
            } else {
                toast.error("Failed to process the request.");
            }
        } catch (error) {
            console.error("Cancel Error:", error);
            toast.error("An error occurred while processing cancellation.");
        }
    };
    const updateRefund = async (order) => {
        const reason = document.querySelector('textarea[name="comment"]').value.trim();
        if (!reason) {
            toast.error("Please enter a reason for cancellation.");
            return;
        }

        // Refund checkbox is selected
        let payload = {
            order_cancellation_reason: reason,
            order_status: 4, // Assuming 4 means Cancelled
        };

        if (showAddOnSection) {
            const refundAmount = document.querySelector('input[placeholder="Enter Refund Amount"]').value.trim();
            if (!refundAmount || isNaN(refundAmount)) {
                toast.error("Please enter a valid refund amount.");
                return;
            }

            payload = {
                ...payload,
                refund_eligible: true,
                refund_amount: refundAmount,
                refund_deducted: refundDeducted,
                refund_days: refundDays,
                refund_eligible_amount: ((Number(order.paid_amount || 0) - Number(refundDeducted || 0)) * (refundEligible || 0) / 100),
                refund_order : order,
                user_id : user_id,
            };
        }

        try {
            const response = await axios.put(`${BaseUrl}/manage_corporate_order/update_order_status/${order.id}/9`, payload);
            if (response.status === 200) {
                toast.success(showAddOnSection ? "Refund requested successfully!" : "Order cancelled successfully!");
                onClose();
                navigate('/manage-corporate-order');
            } else {
                toast.error("Failed to process the request.");
            }
        } catch (error) {
            console.error("Cancel Error:", error);
            toast.error("An error occurred while processing cancellation.");
        }
    };



         useEffect(() => {
                    fetchFunctionType();
                    fetchCateringType();
                    fetchitemSchedule();
                    getSettings();
            }, []);


    return (
        <Modal show={show} onHide={onClose} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title  text-white">Order Cancel</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row mb-4">
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Order Id</label>
                            <div className='d-block'>
                                <label className='text-success font-w600 fs-6 py-0'>{order.catering_id}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Customer Name</label>
                            <div className='d-block'>
                                <label className='text-success font-w600 fs-6 py-0'>{order.customer.customer_name}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Customer Mobile No</label>
                            <div className='d-block'>
                                <label className='text-success font-w600 fs-6 py-0'>{order.customer.customer_number}</label>
                            </div>
                        </div>
                        {/* <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Catering Type</label>
                            <div className='d-block'>
                                <label className='text-success font-w600 fs-6 py-0'>{getCateringTypeLabel(order.catering_type)}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Function Type</label>
                            <div className='d-block'>
                                <label className='text-success font-w600 fs-6 py-0'>{getFunctionTypeLabel(order.function_type)}</label>
                            </div>
                        </div> */}
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Total Cost</label>
                            <div className='d-block'>
                                <label className='text-danger font-w600 fs-6 py-0'>₹ {order.total}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Meals Period</label>
                            <div className='d-block'>
                                <label className='text-success font-w600 fs-6 py-0'>{getMealsPeriodLabel(order.meals_period)}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Head Count</label>
                            <div className='d-block'>
                                <label className='text-white bg-primary px-2 rounded font-w600 fs-6 py-1'>{order.head_count}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Order Date</label>
                            <div className='d-block'>
                                <label className='text-danger font-w600 fs-6 py-0'>{formatDate(order.order_date)}</label>
                            </div>
                        </div>
                    </div>
                    <hr></hr>
                    <div className="row mb-2">
                        <label className='text-danger fs-4 font-w600 mb-1'>"Unable to Cancel: Orders must be changed at least 2 days in advance."</label>
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Reason <span className="required">*</span></label>
                            <textarea rows={1} className="form-control" name="comment" placeholder="Enter Cancel Reason" defaultValue={""}/>
                        </div>
                        <div className='col-lg-6 mb-2'>
                            <div className="form-check custom-checkbox mt-3">
                                <input
                                    type="checkbox"
                                    onChange={handleAddOnToggle}
                                    className="form-check-input me-3"
                                    id="customCheckBox1"
                                    checked={showAddOnSection}
                                />
                                <h4 className='font-w600 text-black' htmlFor="customCheckBox1">Refund Eligible</h4>
                            </div>
                        </div>
                    </div>
                    {showAddOnSection && (
                        <>
                            <div className='row mb-2'>
                               <div className="col-lg-4 mb-2 d-flex flex-column gap-1">
                                    <label className="text-black font-w500 fs-7">Advance Amount</label>
                                    <label className="text-danger font-w600 fs-6">
                                    ₹ {Number(order.advance_amount || 0).toLocaleString('en-IN')}
                                    </label>
                                </div>

                                {/* Paid Amount */}
                                <div className="col-lg-4 mb-2 d-flex flex-column gap-1">
                                    <label className="text-black font-w500 fs-7">Paid Amount</label>
                                    <label className="text-danger font-w600 fs-6">
                                    ₹ {Number(order.paid_amount || 0).toLocaleString('en-IN')}
                                    </label>
                                </div>

                               <div className="col-lg-4 mb-2 d-flex flex-column gap-1">
                                    <label className="text-black font-w500 fs-7">Refund Eligible (in %)</label>
                                    <label className="text-danger font-w600 fs-6">
                                     {refundEligible} %
                                    </label>
                                </div>

                                {/* Eligible Refund Amount */}
                                <div className="col-lg-4 mb-2 d-flex flex-column gap-1">
                                <label className="text-black font-w500 fs-7">Eligible Refund</label>
                                <label className="text-danger font-w600 fs-6">
                                    ₹ {(() => {
                                    const paidAmount = order.paid_amount;
                                    const refundEligiblePercent = refundEligible;

                                    const refundEligibleAmount = (paidAmount * refundEligiblePercent) / 100;

                                    return refundEligibleAmount.toLocaleString('en-IN', { maximumFractionDigits: 2 });
                                    })()}
                                </label>
                                </div>

                                <div className='col-lg-4 mb-2 d-flex flex-column gap-1'>
                                    <label className="text-black font-w500 fs-7">Max Refund Days</label>
                                    <label className="text-danger font-w600 fs-6">{refundDays} Days</label>
                                </div>
                                <div className='col-lg-4 mb-2 d-flex flex-column gap-1'>
                                    <label className="text-black font-w500 fs-7">Refund Amount<span className='required'>*</span></label>
                                    <input type="text" className="form-control" placeholder="Enter Refund Amount" />
                                </div>
                            </div>              
                        </>
                        )}
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                       {showAddOnSection ? (
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={() => updateRefund(order)}>
                            Request Refund <i className="fas fa-angle-double-right ms-2"></i>
                        </Link>
                        ) : (
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={() => updateCancel(order)}>
                            Order Cancel <i className="fas fa-angle-double-right ms-2"></i>
                        </Link>
                        )}
                    </div>
                </div>
            </div>
        </Modal >
    );
};

export default OrderCancelled;
